import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

import { AuthProvider } from "./auth/AuthProvider";
import { AppRoutes } from "./routes";
import { ThemeProvider } from "./theme/ThemeProvider";
import { ToastProvider } from "./ui/ToastProvider";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // The API answers every failure with a typed envelope; blind retries only
        // multiply rate-limited calls, so retry is opt-in per query.
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export function AppProviders({
  children,
  client,
}: {
  children: ReactNode;
  client?: QueryClient;
}): ReactNode {
  const [fallback] = useState(createQueryClient);
  return (
    <QueryClientProvider client={client ?? fallback}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>{children}</AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export function App(): ReactNode {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}
